import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useColaborador } from "../../../../context/ColaboradorContext";

export default function EliminarFoto() {
    const {
        colaboradorSeleccionado,
        modalOpenEliminarFotoColaborador,
        handleOpenEliminarFotoColaborador,
        handleSubmitEliminarFoto,
    } = useColaborador();

    return (
        <MeditocModal
            title="Eliminar foto"
            open={modalOpenEliminarFotoColaborador}
            setopen={handleOpenEliminarFotoColaborador}
            okfunc={handleSubmitEliminarFoto}
            align="center"
            size="small"
        >
            <Grid container spacing={2} className="center">
                <Grid item xs={12}>
                    <Typography paragraph>¿Desea eliminar la foto del colaborador?</Typography>
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre colaborador:" value={colaboradorSeleccionado.sNombreDirectorio} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
